// /api_front/userSearch
import api from "./api";
import { IAddressee } from 'config/interfaces';

const getAll = (values?: IAddressee.Params) => {
  const params = values ? { OFFSET: 0, LIMIT: 1000, ...values } : {};

  return api.patch<IAddressee.Addressee[]>("/api_front/userSearch", params);
}

const getOne = (addresseeId: string) => {
  const params = {
    IDUSUARIO: addresseeId
  };
  return api.patch<IAddressee.Addressee>("/api_front/userSearch", params);
}

const updateAddressee = (values: IAddressee.Addressee) => {
  return api.put<IAddressee.Addressee>("/api_front/clientUser", [values]);
}

interface UpdateStatusProps {
  IDUSUARIO: number,
  STUSUARIO: number
}
const updateStatus = (values: UpdateStatusProps[]) => {
  return api.put("/api_front/clientUser", values);
}

interface RenewCredential {
  IDTRANSACAO: string | number,
  OBS: string
}
const renewCredential = (values: RenewCredential) => {
  return api.put("/api_front/transaction/renew", values);
}

const updateUserGroup = (values: IAddressee.UpdateUserGroup) => {
  const newValues = [values];
  return api.put('/api_front/ClientUserGroupUpdate', newValues);
}

const deleteUserGroup = (values: IAddressee.DeleteUserGroup) => {
  return api.delete('/api_front/ClientUserGroupDelete', { data: values });
}
const addUserGroup = (values: IAddressee.AddUserGroup) => {
  const newValues = [values];
  return api.post('/api_front/ClientUserGroupInsert', newValues);
}

export { getAll, getOne, updateAddressee, updateStatus, renewCredential, updateUserGroup, deleteUserGroup, addUserGroup };
